import { render, staticRenderFns } from "./dispatchOrders.vue?vue&type=template&id=5e8906c0&scoped=true&"
import script from "./dispatchOrders.vue?vue&type=script&lang=js&"
export * from "./dispatchOrders.vue?vue&type=script&lang=js&"
import style0 from "./dispatchOrders.vue?vue&type=style&index=0&id=5e8906c0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e8906c0",
  null
  
)

export default component.exports